<div class="form-array" *transloco="let t">
  <app-input
    [id]="'business-equipment-serial-' + index"
    [control]="serial"
    [label]="label"
    required
    [readonly]="id?.value"
  >
  </app-input>

  <span class="new-printer-n mb">
    <span *ngIf="planModel?.value">
      {{ planModel?.value }}
    </span>
    <span *ngIf="!planModel?.value">
      {{ t('new-printer', { n: index + 1 }) }}
    </span>
  </span>

  <span class="normal-column mb">
    <span>Series</span>
    <span *ngIf="familyName?.value">{{ familyName?.value }}</span>
    <span *ngIf="!familyName?.value">-</span>
  </span>

  <div class="delete" *ngIf="canRemoveTuple && !planModel?.value">
    <span>{{ t('remove') }} </span>
    <mat-icon class="close-button" (click)="removeTuple.emit(index)">
      close
    </mat-icon>
  </div>
</div>
